(function() {
  'use strict';

  angular.module('kzHeaderCard', []);
})();
